export const MAX_ROWS = 8;
export const DESCRIPTION_REQUIRED_VALIDATION_MESSAGE = 'Description is required.';
export const HOURS_REQUIRED_VALIDATION_MESSAGE = 'Hours is required.';